import React, { PureComponent } from "react";
import { Route, Switch, withRouter } from "react-router-dom";

// Pages
const Main = React.lazy(() => import("../pages/Main"));
const ProductDetail = React.lazy(() => import("../pages/ProductDetail"));
const ProductSpecial = React.lazy(() => import("../pages/ProductSpecial"));
const ProductSpecialDetail = React.lazy(() =>
  import("../pages/ProductSpecialDetail")
);
const PageNoMatch = React.lazy(() => import("../pages/PageNoMatch"));
const loading = () => (
  <div className="animated fadeIn pt-3 text-center">Loading...</div>
);

class Layout extends PureComponent {
  render() {
    return (
      <React.Suspense fallback={loading()}>
        <Switch>
          <Route exact path="/" component={Main} />
          {/* <Route exact path="/" component={Test} /> */}
          <Route path={`/productDetail/:id`} component={ProductDetail} />
          <Route path={`/productSpecial`} component={ProductSpecial} />
          <Route
            path={`/productSpecialDetail/:id`}
            component={ProductSpecialDetail}
          />
          <Route path={`/*`} component={PageNoMatch} />
        </Switch>
      </React.Suspense>
    );
  }
}
export default withRouter(Layout);
